import { render, staticRenderFns } from "./KitZohoDeskTickets.vue?vue&type=template&id=23d821d6"
import script from "./KitZohoDeskTickets.vue?vue&type=script&lang=js"
export * from "./KitZohoDeskTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports